export class BillingMonthSelect {
    public year: number;
    public month: BillingMonth[];
    constructor(billingMonthSelect?: BillingMonthSelect) {
        this.year = billingMonthSelect?.year || -1;
        this.month = billingMonthSelect?.month || [];
    }
}

export class BillingMonth {
    public id?: string;
    public month: (number | undefined);
    constructor(billingMonth?: BillingMonth) {
        this.id = uuidv4();
        this.month = billingMonth?.month;
    }
}


function uuidv4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
}